import {
    ApiHandlerDiscreteParameter,
    createHandlerChainRunner,
    HasOnSuccess,
    markSkipOnCompleteIfOnSuccessIsSet,
} from "@insite/client-framework/HandlerCreator";
import { doSubmitCreateAccountForm, SubmitCreateAccountFormApiParameter } from "@store/Services/EmailService";
import StoreApplicationState from "@store/Store/StoreApplicationState";

type SubmitCreateAccountFormParameter = {
    emailRecipients: string;
} & HasOnSuccess;

type HandlerType = ApiHandlerDiscreteParameter<SubmitCreateAccountFormParameter, SubmitCreateAccountFormApiParameter>;

export const PopulateApiParameter: HandlerType = props => {
    const state = (props.getState() as StoreApplicationState).store.pages.createAccountForm;
    props.apiParameter = {
        emailTo: props.parameter.emailRecipients,

        existingAccount: state.fieldValues["existingAccount"],
        existingAccountNumber: state.fieldValues["existingAccountNumber"],
        existingAccountLoginAdminFullName: state.fieldValues["existingAccountLoginAdminFullName"],
        existingAccountLoginAdminEmail: state.fieldValues["existingAccountLoginAdminEmail"],
        businessName: state.fieldValues["businessName"],
        businessType: state.fieldValues["businessType"],
        materialsItemsRequested: state.fieldValues["materialsItemsRequested"],
        firstName: state.fieldValues["firstName"],
        lastName: state.fieldValues["lastName"],
        role: state.fieldValues["role"],
        emailAddress: state.fieldValues["emailAddress"],

        address: state.fieldValues["address"],
        city: state.fieldValues["city"],
        stateName: state.fieldValues["stateName"],
        countryName: state.fieldValues["countryName"],
        postalCode: state.fieldValues["postalCode"],
        phoneNumber: state.fieldValues["phoneNumber"],
        faxNumber: state.fieldValues["faxNumber"],

        foundOurSite: state.fieldValues["foundOurSite"],
        message: state.fieldValues["message"],
    };
};

export const SendDataToApi: HandlerType = async props => {
    await doSubmitCreateAccountForm(props.apiParameter);
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    markSkipOnCompleteIfOnSuccessIsSet(props);
    props.parameter.onSuccess?.();
};

export const chain = [PopulateApiParameter, SendDataToApi, ExecuteOnSuccessCallback];

const submitCreateAccountForm = createHandlerChainRunner(chain, "SubmitCreateAccountForm");
export default submitCreateAccountForm;
